import { Typography } from '@neo4j-ndl/react';
import { LOG_USER_TYPE } from '@nx/state';

import { InformationIconWithTooltip } from '../../../shared/components';

export const UserCell = ({ user, userType }: { user: string; userType: LOG_USER_TYPE }) => {
  return (
    <div className="flex flex-wrap items-center gap-1">
      <Typography variant={'body-medium'}>{user}</Typography>
      {userType === LOG_USER_TYPE.AURA && (
        <InformationIconWithTooltip
          tooltip="This username is derived from Aura project user credentials that were used with tool authentication."
          isPortaled
        />
      )}
    </div>
  );
};
